<template>
  <div class="alert-light-simple">
    <slot />
  </div>
</template>
